import React from 'react';
import "../map/CrimeMap.css";
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const drawerWidth = 280;

const useStyles = makeStyles({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        marginLeft: props => props.sidebarWidth,
        zIndex: 500
    },
    drawerPaper: {
        position: 'absolute',
        width: drawerWidth,
        marginLeft: props => props.sidebarWidth,
        zIndex: 500
    },
    closeButton: {
        display: 'flex',
        justifyContent: 'flex-end'
    }
});

const FilterPanel = (props) => {
    const classes = useStyles(props);

    return (
        <Drawer
            variant='persistent'
            open={props.selected}
            className={classes.drawer}
            classes={{
                paper: classes.drawerPaper,
            }}>
            <div className={classes.closeButton}>
                <IconButton onClick={props.close}><FontAwesomeIcon icon={faTimes}/></IconButton>
            </div>
            {props.children}
        </Drawer>
    );
}

export default FilterPanel;
